module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/mentors__02-84b46f22c8b19bca3b604937bbce2fb3.jpg";